<template>
  <div class="pt-1">
    <!-- <vs-input  v-model="params.value.value" :placeholder="params.value.placeholder"/> -->
     <b-form-input
          
        v-model="params.value.value"
        :type="params.value.type"
        :placeholder="params.value.placeholder"
          :required="params.value.required"
        ></b-form-input>

  </div>
</template>

<script>
export default {
  data() {
    return {
      text: null
    }
  },
  mounted() {
    // console.log("params", this.params);
  },
  methods: {}
};
</script>
